import React from "react";
import MarketingPage from "../components/marketing/MarketingPage";
import BookDemo from "../components/marketing/BookDemo";

// Standalone home for the booking flow, so "book a demo" links in emails and
// outbound replies land on the picker instead of the middle of the homepage.
export default function BookDemoPage() {
  return (
    <MarketingPage
      seo={{
        title: "Book a Collavue demo",
        description:
          "Pick a 20-minute slot and we'll run a live lead search against your market — real posts, real intent scores, no scripted demo data.",
        path: "/book-demo",
        keywords:
          "Collavue demo, book a demo, AI lead generation demo, X lead generation demo, LinkedIn lead generation demo",
      }}
    >
      <BookDemo />
    </MarketingPage>
  );
}
